import { Link } from 'react-router-dom';
import DomainBadges from '../../DomainBadges';
import './DomainsInterestsTile.scss';

interface DomainsInterestsTileProps {
  domains?: string[];
  interests?: string[];
  interestsHref?: string | null;
}

export function DomainsInterestsTile({
  domains = [],
  interests = [],
  interestsHref,
}: DomainsInterestsTileProps) {
  const isEmpty = domains.length === 0 && interests.length === 0;
  return (
    <div className="domains-interests">
      <p className="domains-interests__cap">Domains &amp; interests</p>
      {domains.length > 0 ? <DomainBadges domains={domains} /> : null}
      {interests.length > 0 ? (
        <div className="domains-interests__chips">
          {interests.map((i) => (
            <span key={i} className="domains-interests__chip">
              {i}
            </span>
          ))}
        </div>
      ) : null}
      {isEmpty ? (
        <p className="domains-interests__empty">
          Reputation domains appear here once you&apos;ve published enough to be
          classified.
          {interestsHref ? (
            <>
              {' '}
              <Link to={interestsHref}>Add interests →</Link>
            </>
          ) : null}
        </p>
      ) : null}
    </div>
  );
}
